import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { notification } from 'antd';
import MaterialIcon from '../../components/MaterialIcon';
import Config from '../../constants/appConfig';
import { useParams } from "react-router";
import saveAs from 'file-saver';
import CircularProgress from '@material-ui/core/CircularProgress';

class EditDraw extends React.Component {
  state = {
    guid1: '',
    guid2: '',
    progress: false
  };


  componentDidMount() {
    this.update();
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
    document.removeEventListener('mousedown', this.handleClickOutside);
  };


  update = () => {

  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  append = () => {
    this.setState({ progress: true });
    let apiUrl = `${Config.server}/append_zjob/${this.state.guid1}/${this.state.guid2}`;
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        console.log('res', res);
        if (res.status !== 200) throw res;
        else return res.blob();
      })
      .then(
        (result) => {
          saveAs(result, 'appended.zjob');
          this.setState({ progress: false });
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          } else if (error.status === 500) {
            error.json().then((err) => {
              notification.open({
                message: err.error,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            });
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };


  render() {
    const { res } = this.props;

    return (
      <div>
        <div id="divPro" className="sr-only back-drop" style={{ backgroundColor: '#fff', zIndex: 599 }}>
          <div className="in-back-drop" style={{ position: 'fixed' }}>
            <CircularProgress color="inherit" disableShrink />
          </div>
        </div>
        <div className="divContent">
          {/* input for guid1 */}
          <TextField
            id="guid1"
            label={'Guid 1'}
            value={this.state.guid1}
            onChange={this.handleChange('guid1')}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          {/* input for guid2 */}
          <TextField
            id="guid2"
            label={'Guid 2'}
            value={this.state.guid2}
            onChange={this.handleChange('guid2')}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <div style={{ textAlign: 'right' }}>
            <Button variant="contained" color="primary" onClick={this.append} disabled={!this.state.guid1 || !this.state.guid2}>
              {'Append'}
            </Button>
          </div>
        </div>
      </div>
    );
  };
}

const TextFields1 = EditDraw;

const Box = (props) => {
  const { link, res } = props;
  let { local } = useParams();
  return (
    <div className="rowForm maxH">
      <TextFields1 link={link} local={local} res={res} />
    </div>);
}

export default Box;

